import { FunctionComponent } from 'react';
import { Box } from '@rebass/emotion';
import {
  PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as Variant,
  PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants_attributes as VariantAttributes,
} from '../../hook/__generated__/PricingPageShopProduct';

import Price from '../Price';
import StockMessage, { PACKAGE_TYPE } from '../StockMessage';

import { StockIndicatorWrapper } from './styles';

const getAttribute = (
  key: string,
  attributes: Array<VariantAttributes | null>
): VariantAttributes['adminLabel'] => {
  const target = attributes.find((attribute) => attribute?.code === key);

  return target?.adminLabel ?? null;
};

export interface ProductVariantProps {
  variant: Variant;
  countryCode?: string;
}

const ProductVariantInfo: FunctionComponent<ProductVariantProps> = ({
  variant,
  countryCode,
}) => {
  const { priceRange, stockStatus } = variant.product ?? {};
  const packageType = getAttribute('package_type', variant.attributes ?? []);

  return (
    <Box data-testid="product-variant-info">
      <Price price={priceRange} />
      <StockIndicatorWrapper data-testid="product-variant-info-message">
        <StockMessage
          packageType={packageType && PACKAGE_TYPE[packageType]}
          stockStatus={stockStatus}
          countryCode={countryCode}
        />
      </StockIndicatorWrapper>
    </Box>
  );
};

export default ProductVariantInfo;
